import { Navigate } from 'react-router-dom';
import DeniedPage from '../components/pages/DeniedPage';
import helpers from '../services/helpers';

function ProtectedRoute({ account, requiredPermissions=[], children }) {
  const isAuthenticated = helpers.isAuthenticated();
  const token = helpers.getToken();

  // Normalize permissions
  const userPermissions = account?.permissions ?? ['superAdmin'];
  const isAuthorized = helpers.checkPermissions(requiredPermissions, userPermissions);

  // Handle unauthenticated access
  if (!isAuthenticated || !token || token === 'undefined' || token === undefined) {
    return <Navigate replace to="/login" />;
  }

  // Handle permission denial
  if (requiredPermissions.length > 0 && !isAuthorized) {
    return <DeniedPage />;
  }

  return children;
}

export default ProtectedRoute;